import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link, Router } from 'react-router';
import { push } from 'react-router-redux';
import AvatarEdit from '../components/AvatarEdit'
import { uploadAvatar } from '../actions/index'
import { UserIsAuthenticated, UserIsVerified } from '../utils/auth'
import ProfileProfile from './ProfileProfile';

class ProfileSidebarNav extends Component {
  render() {



    let myListingLink = '';
    let claimOrgId = '';

    if (this.props.auth.user.organizationClaim && this.props.auth.user.organizationClaim.organization){
      claimOrgId = this.props.auth.user.organizationClaim.organization;



      myListingLink = <li className="profile-sidebarNavItem">
        <Link onClick={this.props.onNavItemClick} className="profile-sidebarNavItemAnchor mylisting"
        to={`/organizations/${claimOrgId}`}>
          <span className="fa-stack">
              <i className="fa fa-circle fa-stack-2x"></i>
              <i className="fa fa-group fa-inverse fa-stack-1x"></i>
          </span>
          <span className="profile-sidebarNavItemText">My Listing</span>
        </Link>
      </li>

    } else {
      myListingLink = '';
    }

    return (
      <ul className="profile-sidebarNavList">
        {/*
        <li className="profile-sidebarNavItem">
          <Link onClick={this.props.onNavItemClick} className="profile-sidebarNavItemAnchor" to="/my">
            <span className="fa-stack">
                <i className="fa fa-circle fa-stack-2x"></i>
                <i className="fa fa-user fa-inverse fa-stack-1x"></i>
            </span>
            <span className="profile-sidebarNavItemText">My Profile</span>
          </Link>
        </li>
        */
        <li onClick={this.props.onNavItemClick} className="profile-sidebarNavItem">
          <Link className="profile-sidebarNavItemAnchor suggestions" to="/my/suggestions">
            <span className="fa-stack">
                <i className="fa fa-circle fa-stack-2x"></i>
                <i className="fa fa-lightbulb-o fa-inverse fa-stack-1x"></i>
            </span>
            <span className="profile-sidebarNavItemText">Suggestions for me</span>
          </Link>
        </li>
        }

        <li className="profile-sidebarNavItem">
          <Link onClick={this.props.onNavItemClick} className="profile-sidebarNavItemAnchor favorites" to="/my/favorites">
            <span className="fa-stack">
                <i className="fa fa-circle fa-stack-2x"></i>
                <i className="fa fa-group fa-inverse fa-stack-1x"></i>
            </span>
            <span className="profile-sidebarNavItemText">My Favorites</span>
          </Link>
        </li>

        <li className="profile-sidebarNavItem">
          <Link onClick={this.props.onNavItemClick} className="profile-sidebarNavItemAnchor interests" to="/my/interests">
            <span className="fa-stack">
                <i className="fa fa-circle fa-stack-2x"></i>
                <i className="fa fa-heart fa-inverse fa-stack-1x"></i>
            </span>
            <span className="profile-sidebarNavItemText">My Interests</span>
          </Link>
        </li>

        <li className="profile-sidebarNavItem">
          <Link onClick={this.props.onNavItemClick} className="profile-sidebarNavItemAnchor account" to="/my/account">
            <span className="fa-stack">
                <i className="fa fa-circle fa-stack-2x"></i>
                <i className="fa fa-gear fa-inverse fa-stack-1x"></i>
            </span>
            <span className="profile-sidebarNavItemText">My Account</span>
          </Link>
        </li>

        <li className="profile-sidebarNavItem">
          <Link onClick={this.props.onNavItemClick} className="profile-sidebarNavItemAnchor recommend" to="/my/recommend">
            <span className="fa-stack">
                <i className="fa fa-circle fa-stack-2x"></i>
                <i className="fa fa-thumbs-up fa-inverse fa-stack-1x"></i>
            </span>
            <span className="profile-sidebarNavItemText">Recommend a resource</span>
          </Link>
        </li>

        {myListingLink}

      </ul>
    );
  }
}


class Profile extends Component {
  state = {
    subMenuOpen: false,
    pageTitleText: 'My Profile'
  };

  constructor(props) {
    super(props);
  }

  handleTitleClick = (e) => {

    this.setState({ subMenuOpen: !this.state.subMenuOpen });
  };

  handleSidebarNavItemClick = (e) => {
    this.setState({ subMenuOpen: false, pageTitleText: e.target.textContent });
  };

  componentDidMount() {
    if (typeof(window) !== "undefined") {
      window.scrollTo(0,0)
    }
  }

  componentWillMount() {
    const { auth } = this.props;
    if (!auth.isLoading && !auth.user) {
      this.props.push('/')
      return
    }
  }
  componentWillReceiveProps(nextProps) {
    const { auth } = nextProps;
    if (!auth.isLoading && !auth.user) {
      this.props.push('/')
      return
    }
  }


  render() {
    var pageTitleHTML = '',
      sidebar = '',
      children = '';
    const { user } = this.props.auth;

    if(!user) {
      return <div><i className="fa fa-spinner fa-spin"></i></div>;
    }



    if(this.state.subMenuOpen || this.props.browser.greaterThan.desktop) {
      sidebar = <ProfileSidebarNav auth={this.props.auth} onNavItemClick={this.handleSidebarNavItemClick}/>;
    }

    if(this.state.pageTitleText == 'My Profile') {
      children = <ProfileProfile />;
    } else {
      children = this.props.children;
    }


    pageTitleHTML = <div onClick={this.handleTitleClick} className="profile-pageTitle">
        {this.state.pageTitleText} <i className="fa fa-chevron-down"></i>
    </div>;

    return (
      <div className="profile-inner">
        <div className="collage-wrapper">
          <div className="profile-banner">
            <img src="/images/others/default-cover.jpg" />
          </div>
          <div className="profile-userInfo">
            <div className="profile-userInfoText">
              <div className="profile-userInfoName">{user.first_name} {user.last_name}</div>
              <div className="profile-userInfoOccupation">{user.occupation}</div>
            </div>
            <div className="profile-userInfoDisplayPicture">
              <AvatarEdit picture={user.display_picture} onChanged={this.props.uploadAvatar}/>
            </div>
          </div>
        </div>
        <div className="content-wrapper">
          {pageTitleHTML}
          <div className="profile-auxWrapper" >
            <div className="profile-sidebar"> {sidebar} </div>
            <div className="profile-content">
              {this.props.children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Profile.propTypes = {
  uploadAvatar: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return state;
}

export default connect(mapStateToProps, { push, uploadAvatar })(Profile)



// WEBPACK FOOTER //
// ./src/containers/Profile.jsx